var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.039 38.8419C15.2889 38.8419 11.623 37.7299 8.50483 35.6464C5.38671 33.563 2.95643 30.6017 1.52132 27.137C0.0862083 23.6723 -0.289284 19.8599 0.442329 16.1818C1.17394 12.5037 2.9798 9.12522 5.63155 6.47348C8.28329 3.82174 11.6618 2.01588 15.3399 1.28426C19.018 0.552646 22.8304 0.928137 26.2951 2.36325C29.7597 3.79836 32.721 6.22864 34.8045 9.34676C36.888 12.4649 38 16.1308 38 19.8809C38 24.9097 36.0023 29.7325 32.4465 33.2884C28.8906 36.8443 24.0678 38.8419 19.039 38.8419Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 16.7607L19.041 23.2607L25.541 16.7607",
    stroke: "#142C41",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrow);
export default __webpack_public_path__ + "static/media/accordion_arrow.4fbcb01efaeb604983203d60b571138b.svg";
export { ForwardRef as ReactComponent };